var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2286 1.85871C13.1531 1.58877 13.0092 1.3429 12.8108 1.14491C12.6123 0.946921 12.3662 0.803516 12.096 0.728585C11.0821 0.457532 7.0062 0.457533 7.0062 0.457533C7.0062 0.457533 2.93797 0.45103 1.9135 0.728585C1.64383 0.803846 1.39813 0.9474 1.20016 1.14537C1.00219 1.34335 0.858633 1.58904 0.783373 1.85871C0.590832 2.89669 0.496003 3.95042 0.500129 5.00609C0.49825 6.05668 0.593065 7.10522 0.783373 8.13843C0.858877 8.40825 1.00247 8.65413 1.20038 8.85246C1.39828 9.05079 1.64385 9.19491 1.9135 9.271C2.92741 9.54205 7.0062 9.54205 7.0062 9.54205C7.0062 9.54205 11.072 9.54205 12.096 9.271C12.3661 9.19524 12.6122 9.05126 12.8105 8.85291C13.0089 8.65457 13.1529 8.40852 13.2286 8.13843C13.4151 7.10583 13.5062 6.05576 13.4997 5.00609C13.5062 3.94952 13.4172 2.89782 13.2286 1.85871ZM5.70417 6.95141V3.05224L9.097 5.00609L5.70417 6.95141Z",
    fill: "url(#paint0_linear_2590_44831)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2590_44831",
    x1: 7,
    y1: -1.1777,
    x2: 7,
    y2: 10.9956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.c3297da02cddab0c2f32301c335ce143.svg";
export { ForwardRef as ReactComponent };